<template>
  <treeDetail :source="source" :osStartTime="osStartTime" :clientId="clientId" :list="source.children" :num="0" />
</template>
<script>
import treeDetail from './tree.vue'
export default {
  components: {
    treeDetail
  },
  name: 'Items',
  props: {
    clientId: {
      type: String
    },
    isShowHideVal: {
      type: Boolean
    },
    osStartTime: '',
    isShowHide: {
      type: Boolean
    },
    index: {
      type: Number
    },
    rowClick: {
      type: Function
    },
    expend: Function,
    source: {
      type: Object,
      default () {
        return {
        };
      }

    }
  },
  watch: {
    // '$store.state.user' () {
    //   console.log(121)
    //   console.log(this.$store.state.user.isShowProcess)
    // }
  },
  // mounted () {
  //   console.log(this.isShowHideVal)
  // },
  data () {
    return {
      columns: [
        {
          title: '进程路径',
          key: 'fullPath',
          align: 'center',
          tooltip: true,
          width: 400,
          tree: true,
        },
        {
          title: '公司名称',
          key: 'fileProductName',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '进程ID',
          key: 'pid',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '父进程ID',
          key: 'parentPid',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          resizable: true,
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
        },
      ],
    }
  },
  methods: {
    // selectItem (val) {
    //   console.log(val)
    // }
  },
}
</script>
<style lang="scss" scoped>
table {
  width: 1444px;
  border: 0;

  tr,
  td {
    text-align: left;
    border-color: #eee;
  }

  td {
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    display: inline-block;
    -webkit-line-clamp: 1; // 超出多少行
    -webkit-box-orient: vertical;
    line-height: 30px;
    height: 30px;
  }

  .f20 {
    text-align: center;
    width: 20px;
    height: 20px;
    text-indent: 2px;
    line-height: 20px;
    background: #eee;
    left: 4px;
  }

  .tac {
    text-align: center;
  }

  .boxSizing {
    box-sizing: border-box !important;
  }

  .dieState {
    background: #eee;
  }
}
</style>